import { BrowserRouter as Router } from "react-router-dom";
import { AppRoutes } from "./routes/appRoutes/appRoutes";
import { SwitchRoute } from "./components/route/SwitchRoute";
import BetaVersion from "components/betaVersion/betaVersion";
import RichTextEditor from "./components/RichTextEditor";
function App() {
  return (
    <div className="h-100">
      {process.env.REACT_APP_BETA_VERSION ==="TRUE" && <BetaVersion/>}
      <Router>
        <SwitchRoute routes={AppRoutes} />
      </Router>
    </div>
  );
}

export default App;
